import React from 'react';
import Container from 'Nori/Container';
import RichText from 'Custom/RichText';
import styles from 'Custom/Duration/index.module.scss';
import DottedLine from 'Images/brand-icons/dotted-line.svg';
import { CHART_COLUMNS } from './utils';
import Button from 'Nori/Button';
import BackgroundImage from 'Nori/BackgroundImage/index';
import WHITE_MARBLE_BG_IMAGE from 'Images/misc/common-ques-desktop.png';
import WHITE_MARBLE_BG_IMAGE_MOBILE from 'Images/misc/common-ques-mobile.png';

const Duration = ({
  enableLearnMoreBtn = true,
  sectionClassName = '',
  className = '',
  title = '',
  href = '',
  cols = CHART_COLUMNS,
  children,
  anchorID = '',
  ...props
}) => (
  <section className={styles.sectonDuration} id={anchorID}>
    <BackgroundImage
      image={WHITE_MARBLE_BG_IMAGE}
      mobileImage={WHITE_MARBLE_BG_IMAGE_MOBILE}
      imageClass={styles.durationBgImage}
    >
      <div className={`${styles.duration} ${className}`} {...props}>
        <Container size="md">
          {title && <h4 className={styles.sectionTitle}>{title}</h4>}
          <RichText className={styles.sectionContent}>{children}</RichText>
          {Boolean(cols.length) && (
            <>
              <div className={styles.durationChart} data-qa-tag="duration box">
                {cols.map((col, index) => (
                  <React.Fragment key={`col-${index}`}>
                    <div className={styles.chartCol}>
                      <div
                        className={styles.chartLabel}
                        data-qa-tag="duration pink lable"
                      >
                        <div className={styles.chartText}>{col.label}</div>
                      </div>
                      <RichText>{col.content}</RichText>
                      {/* <DottedLine aria-hidden="true" /> */}
                    </div>
                    <div className={styles.dotlineImg}>
                      <DottedLine aria-hidden="true" />
                    </div>
                  </React.Fragment>
                ))}
              </div>
            </>
          )}
          {enableLearnMoreBtn && (
            <Button
              type="primary"
              href="/what-to-expect/"
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Link"
              data-design-label="Learn More About Insertion Aftercare"
              data-design-nori_id="Inline Content"
              data-design-module_name="insertion aftercare"
              data-design-module_no="06"
              className={styles.cta}
              data-qa-tag="button Learn More About Insertion Aftercare"
            >
              Learn More About Insertion Aftercare
            </Button>
          )}
        </Container>
      </div>
    </BackgroundImage>
  </section>
);

export default Duration;
